var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveriesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 128 167 L 257 96 L 386 167 L 257 240 Z M 128 167 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 128 167 L 128 328 L 257 403 L 257 240 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 386 167 L 386 275 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 257 240 L 386 167 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 202 126 L 330 198 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 230 111 L 358 182 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 437 338 C 437 292.692308 400.307692 256 355 256 C 309.692308 256 273 292.692308 273 338 C 273 383.307692 309.692308 420 355 420 C 400.307692 420 437 383.307692 437 338 Z M 437 338 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 18,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(61.176473%,63.921571%,68.627453%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 316 338 L 344 366 L 397 310 ",
    transform: "matrix(0.0507812,0,0,0.0507812,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveriesIcon);
export default __webpack_public_path__ + "static/media/deliveries_icon.3f962bfc5dd3cc74cca1d7ddd1ac4a15.svg";
export { ForwardRef as ReactComponent };